import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(arr: any[], prop: string, value: string): any {
    if (arr) {
      if (!value) {
        return arr;
      } else {
        return arr.filter(
          obj => obj[prop].toLowerCase().indexOf(value.toLowerCase()) > -1
        );
      }
    } else {
      return [];
    }
  }
}
